<div class="cf-templates-dialog">
  <div>
    <span>Message templates</span>
  </div>
  <div class="import-dialog-content">
    <dl-message-attachment-template [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newMessageTemplate"
      [displayedColumns]="templateColumn" [tableData]="templateData"
      (isMessageRowSelected)="getSelectedRowInTemplate($event)"></dl-message-attachment-template>
  </div>
  <div oneDialogActions class="import-dialog-actions" style="display: flex;">
    <owc-button (click)="closeDialog.emit()" class="cancel-btn">
      Cancel
    </owc-button>
    <owc-button color="primary" [disabled]="isNtBtnDisabled" (click)="openNewTemplateAction()">
      New template
    </owc-button>

    <owc-modal-dialog [(ngModel)]="visibleTemplate" size="large">
      <dl-add-own-template-dialog [data]="data" (closeDialog)="visibleTemplate = false"></dl-add-own-template-dialog>
    </owc-modal-dialog>
    <owc-button color="primary" [disabled]="isAffBtnDisabled" (click)="addTemplateToForm()">
      Select
    </owc-button>
  </div>
</div>